import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const rivoSettings = defineIntegrationSettings({
  fields: { rewardsPageUrl: z.string().trim().nullable() },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
